import { IConfig } from "../types/config";

const config: IConfig = {
  base_url: "https://staging-decide-api.indicina.net",
  linkedin_tracking_id: 8481130,
};

export default config;
